/**
 * Exhaustiveness helper for switch/if-else chains over a union or enum.
 * TypeScript narrows `x` to `never` when all cases are handled; the runtime
 * throw catches mistakes at development time if a new variant is added later.
 */
export function assertNever(x: never): never {
  throw new Error(`Unhandled variant: ${String(x)}`);
}
